import { render, staticRenderFns } from "./collectionInformation.vue?vue&type=template&id=e44de7f8&scoped=true"
import script from "./collectionInformation.vue?vue&type=script&lang=js"
export * from "./collectionInformation.vue?vue&type=script&lang=js"
import style0 from "./collectionInformation.vue?vue&type=style&index=0&id=e44de7f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e44de7f8",
  null
  
)

export default component.exports